export const env = {
  api: {
    url: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:1337'
  },
  config: {
    projectName: process.env.NEXT_PUBLIC_PROJECT_NAME || 'Gazin Web',
  }
}